import {
  RESET_CREATE_TRANSACTION_DETAILS_AND_RES_OBJ,
  SET_SELECTED_ACCORDION,
} from "../action.js";
import { selectedAccordion } from "./initial-store.js";

const initialState = selectedAccordion;

function selectedAccordionReducer(state = initialState, action) {
  switch (action.type) {
    case SET_SELECTED_ACCORDION:
      return action.payload;
    case RESET_CREATE_TRANSACTION_DETAILS_AND_RES_OBJ:
      return "Customer & Deal Information";
    default:
      return state;
  }
}

export default selectedAccordionReducer;
